export default __webpack_public_path__ + "static/media/Favorite_selected.052ce66f.svg";